import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMoreVertical = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={24} height={25} fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M12 13.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 6.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M12 20.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2'
    />
  </svg>
);
export default SvgMoreVertical;
